import { mapFiltersData } from "../../helpers/mapFiltersData"
import { FiltersApi, FiltersState, SDT } from "./types"

export const initApi = (state_: FiltersState, setState_: SDT): FiltersApi => {

  const getValues = (): any => (mapFiltersData(state_.values))

  const setValues = (values: any): void => {
    setState_((state) => ({
      ...state,
      values,
    }))
  }

  const resetValues = (): void => {
    setState_((state) => ({
      ...state,
      values: {}
    }))
  }

  return {
    getValues,
    setValues,
    resetValues,
  }
}

